<div class="container">
  <div class="header">
    <img src="/assets/img/logo-web.png" alt="Cabanga logo" class="logo"/>

    <p>Page inconnue</p>
    <p>La page demandée n'existe pas, veuillez revenir à l'écran d'accueil.</p>
  </div>
  <div class="browsers">
    <button mat-button type="button" (click)="reloadApp()" color="primary">Vers l'écran d'accueil</button>
  </div>
</div>
